import { useEffect, useState } from "react";
import { events, eventStatuses } from "../../../misc/constants";
import arrow from "../../../assets/svg/arrow-right-blue.svg";
import arrowWhite from "../../../assets/svg/arrow-left-white.svg";
import arrowUp from "../../../assets/svg/arrow-gray-up.svg";
import arrowDown from "../../../assets/svg/arrow-gray-down.svg";
import trash from "../../../assets/svg/trash-box-red.svg";
import copy from "../../../assets/svg/copy-gray.svg";
import share from "../../../assets/svg/share-gray.svg";
import ControlBtn from "./ControlBtn";

export default function EventsTable({
  openEventId,
  setOpenEventId,
  filteredEvents,
  setFilteredEvents,
  isAddingEvent,
  setEvents,
}) {
  const [localEvents, setLocalEvents] = useState(events);
  const [sortOrder, setSortOrder] = useState(null);
  const [statusSortOrder, setStatusSortOrder] = useState(null);

  useEffect(() => {
    setLocalEvents(events);
  }, [events]);

  const toggleMenu = (eventId) => {
    setOpenEventId(openEventId === eventId ? null : eventId);
  };

  const handleDelete = (eventId) => {
    const updatedEvents = localEvents.filter((event) => event.id !== eventId);
    setLocalEvents(updatedEvents);

    if (filteredEvents !== events) {
      const updatedFilteredEvents = filteredEvents.filter(
        (event) => event.id !== eventId
      );
      setFilteredEvents(updatedFilteredEvents);
    } else {
      setFilteredEvents(updatedEvents);
    }

    setEvents(updatedEvents);
  };

  const sortEventsByTitle = (direction) => {
    const sortedEvents = [...filteredEvents].sort((a, b) => {
      if (direction === "asc") {
        return a.title.localeCompare(b.title);
      } else if (direction === "desc") {
        return b.title.localeCompare(a.title);
      }
      return 0;
    });

    setFilteredEvents(sortedEvents);
    setSortOrder(direction);
  };

  const sortEventsByStatus = (direction) => {
    const sortedEvents = [...filteredEvents].sort((a, b) => {
      const statusA = a.status === "Опубликовано" ? 0 : 1;
      const statusB = b.status === "Опубликовано" ? 0 : 1;

      if (direction === "asc") {
        return statusA - statusB;
      } else if (direction === "desc") {
        return statusB - statusA;
      }
      return 0;
    });

    setFilteredEvents(sortedEvents);
    setStatusSortOrder(direction);
  };

  return (
    <div className="p-4">
      <div className="flex flex-row border-b border-b-[$F0F3FA] pt-2 pb-4">
        <div
          className={`pl-2 flex flex-row justify-center ${
            openEventId || isAddingEvent ? "w-[40%]" : "w-[17%]"
          }`}
        >
          <span className="text-[#5F6B88] font-medium text-sm">
            Изображение
          </span>
        </div>
        <div
          className={`pl-2 flex flex-row ${
            openEventId ? "w-[45%]" : "w-[15%]"
          }`}
        >
          <span className="text-[#5F6B88] font-medium text-sm flex items-center gap-[6px]">
            Заголовок{" "}
            <div className="flex flex-col gap-1">
              <img
                src={arrowUp}
                alt="arrow-up"
                onClick={() => sortEventsByTitle("asc")}
                className="cursor-pointer"
              />
              <img
                src={arrowDown}
                alt="arrow-down"
                onClick={() => sortEventsByTitle("desc")}
                className="cursor-pointer"
              />
            </div>
          </span>
        </div>

        {!openEventId && !isAddingEvent && (
          <>
            <div className="w-[14%] pl-2 flex flex-row justify-center">
              <span className="text-[#5F6B88] font-medium text-sm flex items-center gap-[6px]">
                Дата публикации
                <div className="flex flex-col gap-1">
                  <img
                    // onClick={() => sortEventsByTitle("asc")}
                    src={arrowUp}
                    alt=""
                    className="cursor-pointer"
                  />
                  <img
                    // onClick={() => sortEventsByTitle("desc")}
                    src={arrowDown}
                    alt=""
                    className="cursor-pointer"
                  />
                </div>
              </span>
            </div>
            <div className="w-[11%] pl-2 flex flex-row justify-center">
              <span className="text-[#5F6B88] font-medium text-sm">
                Внешняя ссылка
              </span>
            </div>
            <div className="w-[20%] pl-2 flex flex-row ml-4">
              <span className="text-[#5F6B88] font-medium text-sm flex items-center gap-[6px]">
                Статус события
                <div className="flex flex-col gap-1">
                  <img
                    src={arrowUp}
                    alt="arrow-up"
                    onClick={() => sortEventsByStatus("asc")}
                    className="cursor-pointer"
                  />
                  <img
                    src={arrowDown}
                    alt="arrow-down"
                    onClick={() => sortEventsByStatus("desc")}
                    className="cursor-pointer"
                  />
                </div>
              </span>
            </div>
            <div className="w-[22%] pl-2 flex flex-row">
              <span className="text-[#5F6B88] font-medium text-sm"></span>
            </div>
          </>
        )}
      </div>

      {filteredEvents.map((event) => (
        <div
          className={`flex flex-row border-b border-b-[$F0F3FA] py-3 h-40 rounded-l ${
            openEventId === event.id ? "bg-[#0068FF] " : ""
          }`}
          key={event.id}
        >
          <div
            className={`cursor-pointer ${
              openEventId || isAddingEvent ? "w-[45%]" : "w-[17%]"
            } pl-2 flex flex-row items-center `}
          >
            {!isAddingEvent && (
              <img
                className="w-10"
                src={openEventId === event.id ? arrowWhite : arrow}
                onClick={() => toggleMenu(event.id)}
              />
            )}

            <span className="ml-4 font-medium text-[15px] text-[#1A1A1A]">
              <img
                src={event.img}
                alt="event"
                className={`rounded-lg w-36 h-20 ${
                  openEventId === event.id ? "opacity-100" : "opacity-50"
                }`}
              />
            </span>
          </div>

          <div
            className={`${
              openEventId || isAddingEvent ? "w-[45%]" : "w-[15%]"
            } pl-2 flex flex-row items-center`}
          >
            <span
              className={`${
                openEventId === event.id ? "text-white " : "text-black"
              } text-base font-medium`}
            >
              {event.title}
            </span>
          </div>

          {!openEventId && !isAddingEvent && (
            <div className="w-[14%] pl-2 flex flex-row items-center justify-center text-black font-medium text-[15px]">
              {event.publishDate}
            </div>
          )}

          {!openEventId && !isAddingEvent && (
            <div className="w-[11%] pl-2 flex flex-row items-center justify-center gap-3 text-black">
              {event.url ? (
                <>
                  <a href={event.url}>
                    <img src={share} alt="Share icon" />
                  </a>
                  <img src={copy} alt="Copy icon" />
                </>
              ) : (
                "-"
              )}
            </div>
          )}

          {!openEventId && !isAddingEvent && (
            <div className="flex justify-around items-center w-[20%]">
              <div className="flex gap-1 items-center w-full ml-4">
                <img
                  src={
                    event.status === eventStatuses[0].status
                      ? eventStatuses[0].img
                      : event.status === eventStatuses[1].status
                      ? eventStatuses[1].img
                      : eventStatuses[2].img
                  }
                  alt="status-icon"
                />
                <p
                  style={{
                    color:
                      event.status === eventStatuses[0].status
                        ? eventStatuses[0].color
                        : event.status === eventStatuses[1].status
                        ? eventStatuses[1].color
                        : eventStatuses[2].color,
                  }}
                  className="font-medium text-base"
                >
                  {event.status}
                </p>
              </div>
            </div>
          )}

          {!openEventId && !isAddingEvent && (
            <div className="w-[22%] pl-2 flex flex-row items-center justify-center gap-2">
              <div className="flex flex-col items-start gap-2">
                {event.actions.map((action, id) => (
                  <ControlBtn text={action} key={id} />
                ))}
              </div>
              <img
                className="ml-auto cursor-pointer"
                src={trash}
                alt="trash"
                onClick={() => handleDelete(event.id)}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
